import { Action, createAction, props } from '@ngrx/store'
import { CreatePurchaseResponse, ItemEntity } from './selected-item.models'
import { Update } from '@ngrx/entity'
import { GbAppPayment, GbPaymentIntent, PreAuthResultEnum } from 'libs/gb-front/payment/util/src/lib/gb-payment.models'
import { HttpErrorResponse } from '@angular/common/http'
import { SlimItemEntity } from 'libs/gb-front/item/data-access/src/lib/+state/items.models'

export const initSelectedItem = createAction('[SelectedItem Page] Init Selected Item', props<{ uuid: string }>())

export const initSelectedItemFieldsFromList = createAction(
  '[SelectedItem Page] Init Selected Item Fields From List',
  props<{ selectedItem: SlimItemEntity | ItemEntity }>(),
)

export const syncSelectedItem = createAction('[SelectedItem Page] Sync Selected Item', props<{ uuid: string }>())

export const syncSelectedItemSuccess = createAction(
  '[SelectedItem/API] Sync SelectedItem Success',
  props<{ selectedItem: ItemEntity }>(),
)

export const syncSelectedItemFailure = createAction(
  '[SelectedItem/API] Sync SelectedItem Failure',
  props<{ error: HttpErrorResponse; uuid: string }>(),
)

export const updateSelectedItem = createAction(
  '[SelectedItem/API] Update Selected Item',
  props<{ update: Update<ItemEntity> }>(),
)

export const clearSelectedItem = createAction('[SelectedItem Page] Clear Selected Item')

/**
 * Bid actions
 */
export const openConfirmBidDialog = createAction('[SelectedItem] Open Confirm Bid Dialog')

export const placeBid = createAction('[Item/API] Place Bid')

export const placeBidSuccess = createAction(
  '[SelectedItem/API] Place Bid Success',
  props<{
    requiresPayment?: boolean | null
    payment?: GbAppPayment | null
  }>(),
)

export const finaliseBidSuccess = createAction('[SelectedItem/API] finalise Bid Success')

export const placeBidFailure = createAction(
  '[SelectedItem/API] Place Bid Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const placeLiveBid = createAction('[SelectedItem/API] Place Live Bid', props<{ payNow?: boolean | null }>())

export const placeLiveBidSuccess = createAction(
  '[SelectedItem/API] Place Live Bid Success',
  props<{
    requiresPayment?: boolean | null
    payment?: GbAppPayment | null
  }>(),
)

export const openAddLiveBidPaymentDialog = createAction('[SelectedItem] Open Add Live Bid Payment Dialog')

/**
 * Donation actions
 */
export const placeDonation = createAction('[SelectedItem/API] Place Donation')

export const placeDonationFailure = createAction(
  '[SelectedItem/API] Place Donation Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const placeDonationSuccess = createAction(
  '[SelectedItem/API] Place Donation Success',
  props<{
    requiresPayment?: boolean | null
    payment?: GbAppPayment | null
  }>(),
)

export const finaliseDonationSuccess = createAction('[SelectedItem/API] Finalise Donation Success')

/**
 * Item action actions
 */
export const placeItemActivity = createAction('[SelectedItem] Place Item Activity')

export const updateAmount = createAction('[SelectedItem] Update Amount', props<{ amount: number }>())

export const checkPaymentRequired = createAction('[SelectedItem] Check Payment Required')

export const openPaymentDialog = createAction('[SelectedItem] Open Payment Dialog')

export const openConfirmationDialogVolunteer = createAction('[SelectedItem] Open Confirmation Dialog Volunteer')

export const cancelPayment = createAction('[SelectedItem] Cancel Payment')

export const openPreAuthDialog = createAction('[Item] Open Pre-Auth Dialog')

export const preAuthSuccess = createAction('[Item] Pre-Auth Success', (result: PreAuthResultEnum) => ({ result }))

export const confirmItemActivity = createAction('[SelectedItem] Confirm Item Activity', (onSuccess?: () => Action) => ({
  onSuccess,
}))

export const confirmItemActivitySuccess = createAction(
  '[SelectedItem] Confirm Item Activity Success',
  props<{ payment?: GbAppPayment | null }>(),
)

export const clearAmount = createAction('[SelectedItem/API] Clear Amount')

/**
 * Purchase actions
 */
export const checkRemainingPurchaseUnits = createAction('[SelectedItem] Check Remaining Purchase Units')

export const placePurchase = createAction('[Item/API] Place Purchase')

export const placePurchaseFailure = createAction(
  '[SelectedItem/API] Place Purchase Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const placePurchaseSuccess = createAction(
  '[SelectedItem/API] Place Purchase Success',
  props<{
    response: CreatePurchaseResponse
    requiresPayment?: boolean | null
    payment?: GbAppPayment | null
  }>(),
)

export const finalisePurchaseSuccess = createAction('[SelectedItem/API] Finalise Purchase Success')

/**
 * Raffle purchase actions
 */
export const checkRemainingRaffleUnits = createAction('[SelectedItem] Check Remaining Raffle Units')

export const placeRafflePurchase = createAction('[SelectedItem/API] Create Raffle Purchase')

export const placeRafflePurchaseSuccess = createAction(
  '[SelectedItem/API] Create Raffle Purchase Success',
  props<{
    requiresPayment?: boolean | null
    payment?: GbAppPayment | null
  }>(),
)

export const finaliseRafflePurchaseSuccess = createAction('[SelectedItem/API] Finalise Raffle Purchase')

export const placeRafflePurchaseFailure = createAction(
  '[SelectedItem/API] Create Raffle Purchase Error',
  props<{ error: HttpErrorResponse }>(),
)

export const openItemTnCDialog = createAction('[SelectedItem] Open Item TnC Dialog')
